import { Tooltip } from '@branchjs/neo-components';
import classNames from 'classnames';
import React from 'react';
import { useHistory, useLocation } from 'react-router';

import { useProductProvisioning } from '../../../../../libraries/branch-neo-next/ProductProvisioningContext/ProductProvisioningContext';
import type { FeatureOptions } from '../../../../../libraries/branch-neo-next/ProductProvisioningContext/types/productProvisioning.types';
import { ImageService } from '../../../services/ImageService/ImageService';
import { LockedPackagingIconClasses, LockedPackagingIconStyles } from './LockedPackagingIcon.styles';

type Props = {
  route: string;
  hide?: boolean;
  className?: string;
  feature?: string | string[];
  featureOptions?: FeatureOptions;
};

const LockedPackagingIcon = ({ route, hide, className, feature, featureOptions }: Props) => {
  const history = useHistory();
  const location = useLocation();

  const { isEnabled, isVidaliaEnabled } = useProductProvisioning();

  const onClick = () => {
    history.push({
      pathname: location.pathname,
      search: `modal=package-modal`,
    });
  };

  if (hide || !isVidaliaEnabled) {
    return null;
  }

  if (feature) {
    const isFeatureEnabled = isEnabled(feature, featureOptions);
    if (isFeatureEnabled) {
      return null;
    }
  }

  return (
    <span
      className={classNames(LockedPackagingIconClasses.container, className)}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <Tooltip
        title={
          <span>
            <a onClick={onClick} id={`Nav-Package-${route}`}>
              Explore plans and add-ons
            </a>
            <br />
            to unlock more of Branch
          </span>
        }
        placement="right"
      >
        <img
          className="tooltip-icon"
          style={LockedPackagingIconStyles.image}
          src={ImageService.getImageUrl('/static/images/navigation/lightning-circle.svg')}
          alt="Locked"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        />
      </Tooltip>
    </span>
  );
};

export default LockedPackagingIcon;
